import actions from './actions';

const { CUSTOM_REPORTS_BEGIN, CUSTOM_REPORTS_SUCCESS, CUSTOM_REPORTS_ERR } = actions;

const initState = {
  loading: false,
  data: {
    total: 0
  },
};

const CustomReportsReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CUSTOM_REPORTS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case CUSTOM_REPORTS_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case CUSTOM_REPORTS_ERR:
      return {
        ...state,
        err,
        loading: false,
      };
    default:
      return state;
  }
};

export default CustomReportsReducer;
